module.exports = __webpack_public_path__ + "assets/img/Striver-Careers-Landing-Page-w720.9f82ba3e.webp";